import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from '../../Components/NavLink/NavLink';
import { Trans } from 'react-i18next';
import './styles/poctabs.scss';

class PocTabs extends React.Component {
    render () {
        const BASE_CLASS = 'pocTabs';

        return (
            <nav className={BASE_CLASS}>
                {
                    this.props.tabs.map((element, i) => (
                        <NavLink
                            exact
                            to={element.link}
                            key={i}
                            activeClassName={`${BASE_CLASS}__tab--active`}
                            className={`${BASE_CLASS}__tab`}
                            gtmAttribute={this.props.gtmAttribute && `${this.props.gtmAttribute}${element.label.toLowerCase()}`}
                        >
                            <Trans>{`sports.${element.label.toLowerCase()}`}</Trans>
                        </NavLink>
                    ))
                }
            </nav>
        );
    }
}

PocTabs.propTypes = {
    tabs: PropTypes.array.isRequired,
    gtmAttribute: PropTypes.string,
};

export default PocTabs;
